"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const constant_1 = require("../../../DST/DSTL001/constant");
const constant_2 = require("../../../DST/DSTSL001/constant");
const funtions_1 = require("../../../DST/DSTT001/funtions");
const action_1 = require("../../../menu/action");
const account_1 = require("../../account");
const classes_1 = require("../../classes");
const functions_1 = require("../../classes/functions");
const popup_1 = require("../../popup");
const LiveEnquiries_1 = require("./LiveEnquiries");
const LiveRoomListPopUp_1 = require("./LiveRoomListPopUp");
const ProfileStyled = styled_components_1.default.div `
	& {
		padding: ${({ $isMobile }) => ($isMobile ? '40px 0' : '80px 0')};
		display: flex;
		flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
		align-items: center;
		justify-content: space-evenly;
		align-self: stretch;
		flex: 1;
		position: relative;
		${({ $isMobile }) => $isMobile &&
    `
			gap: 24px;
			width: 100%;
    		overflow: hidden;
		`}
	}

	${({ $isTablet }) => $isTablet &&
    `
		width: 80%;
	`}

	.left {
		z-index: 1;
		width: 504px;
		min-height: 182px;
		min-width: 60%;

		${({ $isMobile }) => $isMobile &&
    `
			padding: 0 20px;
		display: flex;
		justify-content: center;
		max-width: 100%;
		`}

		${({ $isTablet }) => $isTablet &&
    `
			min-width: 40%;
			max-width: 50%;
		`}
	}

	.profile {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		gap: ${({ $isMobile, $isTablet }) => ($isMobile ? '8px' : $isTablet ? '12px' : '24px')};
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		max-width: ${({ $isMobile }) => ($isMobile ? '90%' : '620px')};
		${({ $isMobile }) => $isMobile && 'width: 100%;'}

		.name-info {
			display: flex;
			flex-direction: row;
			gap: 9px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}

		.dropdown .placeholder {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: ${({ $isTablet, $isMobile }) => $isMobile ? '20px' : $isTablet ? '30px' : '36px'};
			line-height: 46px;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
		}

		.alarm-today {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.info {
				display: flex;
				flex-direction: row;
				gap: 16px;
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				flex-shrink: 0;
				position: relative;

				p {
					color: var(--color-white, #ffffff);
					text-align: left;
					font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
					font-size: var(--h5-font-size, 16px);
					line-height: var(--h5-line-height, 24px);
					letter-spacing: var(--h5-letter-spacing, -0.02em);
					font-weight: var(--h5-font-weight, 700);
					position: relative;
					flex: 1;
				}
			}
		}

		.btn-today {
			background: #2c6273;
			border-radius: 100px;
			padding: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile ? '4px 16px' : '8px 16px'};
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
		}

		.txt {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
			${({ $isTablet, $isMobile }) => $isTablet || $isMobile
    ? `
					font-size: var(--h5-font-size, 16px);
					line-height: var(--h5-line-height, 24px);
					letter-spacing: var(--h5-letter-spacing, -0.02em);
					font-weight: var(--h5-font-weight, 700);
					`
    : `
				
				font-size: var(--h3-font-size, 24px);
				line-height: var(--h3-line-height, 36px);
				letter-spacing: var(--h3-letter-spacing, -0.02em);
				font-weight: var(--h3-font-weight, 700);
			`}

			position: relative;
			flex: 1;
		}

		.today {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile
    ? "var(--b4-font-family, 'Noto Sans KR', sans-serif)"
    : "var(--h5-font-family, 'Noto Sans KR', sans-serif)"};
			font-size: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile ? 'var(--b4-font-size, 14px)' : 'var(--h5-font-size, 16px)'};
			line-height: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile
    ? 'var(--b4-line-height, 28px)'
    : 'var(--h5-line-height, 24px)'};
			letter-spacing: -0.02em;
			font-weight: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile
    ? 'var(--b4-font-weight, 700)'
    : 'var(--h5-font-weight, 700)'};
			position: relative;
		}

		.rectangle-13218 {
			background: #7a8b96;
			flex-shrink: 0;
			width: 1px;
			height: 28px;
			position: relative;
		}

		.btn-today2 {
			cursor: pointer;
			border-radius: 100px;
			border-style: solid;
			border-color: var(--color-white, #ffffff);
			border-width: ${props => (props.$isMobile ? '1px' : '2px')};
			padding: 4px 16px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
		}

		.div {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile
    ? "var(--b4-font-family, 'Noto Sans KR', sans-serif)"
    : "var(--b3-font-family, 'Noto Sans KR', sans-serif)"};
			font-size: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile ? 'var(--b4-font-size, 14px)' : 'var(--b3-font-size, 16px)'};
			line-height: ${({ $isTablet, $isMobile }) => $isTablet || $isMobile
    ? 'var(--b4-line-height, 28px)'
    : 'var(--b3-line-height, 32px)'};
			letter-spacing: -0.02em;
			font-weight: ${({ $isTablet }) => $isTablet ? 'var(--b4-font-weight, 400)' : 'var(--b3-font-weight, 400)'};
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.ic-back {
			flex-shrink: 0;
			width: 16px;
			height: 16px;
			position: relative;
			overflow: visible;
		}
	}

	.class-info {
		background: rgba(16, 16, 16, 0.3);
		border-radius: 16px;
		padding: ${props => (props.$isMobile ? '24px' : '12px 24px')};
		display: flex;
		flex-direction: column;
		gap: 4px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		box-shadow: 0px 0px 12px 0px rgba(32, 32, 32, 0.25);
		overflow: hidden;

		.subject {
			display: flex;
			flex-direction: row;
			gap: 19px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}

		.title {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: -0.02em;
			font-weight: var(--b3-font-weight, 700);
			position: relative;
			width: 64px;
		}

		.txt2,
		.txt3 {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: -0.02em;
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			width: ${({ $isMobile, $isTablet }) => $isMobile ? '200px' : $isTablet ? 'auto' : '302px'};
		}
	}

	.right {
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: flex-end;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		${({ $isMobile }) => $isMobile &&
    `
		    flex: 1;
			width: 80%;
			gap: 16px;
		`}

		${({ $isTablet }) => $isTablet &&
    `
			min-width: 33%;
		`}

		.background {
			background: #217081;
			border-radius: 50%;
			flex-shrink: 0;
			height: ${({ $isTablet, $isMobile }) => ($isMobile ? '139px' : '241px;')};
			position: relative;
			filter: blur(80px);
			position: absolute;
			width: 100%;
			transform: translate(-50%, -50%);
			left: 50%;
			top: 50%;
		}
	}

	.btn-classroom-in {
		background: linear-gradient(94.13deg, rgba(70, 148, 157, 1) 0%, rgba(37, 132, 143, 1) 100%);
		border-radius: ${({ $isTablet, $isMobile }) => ($isMobile ? '8px' : '16px')};
		padding: ${({ $isTablet, $isMobile }) => $isMobile ? '16px 0' : $isTablet ? '32px 10px;' : '46px 128px;'};
		display: flex;
		flex-direction: row;
		gap: 9px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		${({ $isMobile, $isTablet }) => ($isMobile || $isTablet) &&
    `
			width: 100%;
		`}

		&.on {
			background: linear-gradient(
				94.13deg,
				rgba(70, 148, 157, 1) 0%,
				rgba(37, 132, 143, 1) 100%
			);

			p {
				color: var(--color-white, #ffffff);
			}
		}

		&.disabled {
			cursor: default;
			background: var(--color-w_grey, #83868a);
			p {
				color: var(--color-white, #ffffff);
			}
		}

		
		p {
			text-align: center;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: ${({ $isTablet, $isMobile }) => $isMobile ? '20px' : $isTablet ? '24px;' : ' 40px;'};
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
			// width: 290px;
		}
			
		&.spare {
			flex: 1;
			padding: ${({ $isMobile }) => $isMobile ? '12px' : '24px'};
			${({ $isMobile }) => $isMobile && 'align-items: center;'}

			p {
				font-size: ${({ $isTablet, $isMobile }) => $isMobile ? '18px' : $isTablet ? '18px;' : ' 24px;'};
				text-align: ${({ $isMobile }) => $isMobile ? 'center' : 'start'};
			}
		}	
	}

	.btn-classroom-personal {
		border-radius: ${({ $isTablet, $isMobile }) => ($isMobile ? '8px' : '14px')};
		padding: ${({ $isTablet, $isMobile }) => $isMobile ? '16px 0' : $isTablet ? ' 10px;' : ' 16px 68px 16px 68px;'};
		display: flex;
		flex-direction: row;
		gap: 9px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		${({ $isMobile, $isTablet }) => ($isMobile || $isTablet) &&
    `
			width: 100%;
		`}

		&.on {
			background: linear-gradient(
				94.13deg,
				rgba(70, 148, 157, 1) 0%,
				rgba(37, 132, 143, 1) 100%
			);
			p {
				color: var(--color-white, #ffffff);
			}
		}

		&.disabled {
			cursor: default;
			background: var(--color-w_grey, #83868a);
			p {
				color: var(--color-white, #ffffff);
			}
		}


		p {
			text-align: center;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
			font-size: ${({ $isTablet, $isMobile }) => $isMobile ? '20px' : $isTablet ? '18px;' : '24px;'};
			line-height: 150%;
			letter-spacing: var(--h3-letter-spacing, -0.02em);
			font-weight: var(--h3-font-weight, 700);
			position: relative;
			// width: 290px;
		}

		&.spare {
			padding: ${({ $isTablet, $isMobile }) => ($isMobile ? '12px 0;' : $isTablet ? '10px;' : '16px')};
			p {
				font-size: ${({ $isTablet, $isMobile }) => $isMobile ? '18px' : $isTablet ? '18px;' : ' 24px;'};
				text-align: ${({ $isMobile }) => $isMobile ? 'center' : 'start'};
			}
		}
	}

	.enter-buttons {
		display: flex;
		flex-direction: ${({ $isMobile }) => $isMobile ? 'column' : 'row'};
		gap: ${({ $isMobile }) => $isMobile ? '12px' : '20px'};
		align-items: center;
		justify-content: center;
		width: 100%;
	}

	.secondary-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
		width: 100%;
	}

	.btn-qna-link {
		width: fit-content;
		align-self: flex-end;
		background: transparent;
		border: 0;
		padding: 0;
		margin: 0;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '20px')};
		font-weight: 700;
		line-height: 1.2;
		text-decoration: underline;
		text-underline-offset: 2px;
		color: #7a8b96;
		z-index: 1;

		&.disabled {
			cursor: default;
		}

		&.on {
			color: #fff;
			cursor: pointer;
		}
	}


`;
exports.Profile = react_1.default.memo(() => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { classesId, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const user = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserInfo)(state));
    const classes_data = (0, react_redux_1.useSelector)((state) => (0, functions_1.getClasses)(state));
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, functions_1.getHiddenMenus)(state));
    const manager_local_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsManagerAndUserId)(state));
    const [classes, setClasses] = (0, react_1.useState)(classesId);
    const [liveRoomName, setLiveRoomName] = (0, react_1.useState)();
    const [liveRoomId, setLiveRoomId] = (0, react_1.useState)();
    const [liveRoomCount, setLiveRoomCount] = (0, react_1.useState)(0);
    const [individualLive, setIndividualLive] = (0, react_1.useState)([]);
    const [enquiriesList, setEnquiriesList] = (0, react_1.useState)([]);
    const [isOpenLive, setIsOpenLive] = (0, react_1.useState)(false);
    const [hasSpareLive, setHasSpareLive] = (0, react_1.useState)(false);
    const [spareLiveDatas, setSpareLiveDatas] = (0, react_1.useState)(undefined);
    // 현재 시간
    // const startOfDay = useMemo(() => moment().startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'), []);
    const startOfYesterday = (0, react_1.useMemo)(() => (0, moment_1.default)().subtract(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ'), []);
    // 오늘의 끝 시간 (23:59:59)
    const endOfDay = (0, react_1.useMemo)(() => (0, moment_1.default)().endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'), []);
    const { data, refetch } = (0, server_1.useConferenceList)({
        start_before: endOfDay,
        // start_after: startOfDay,
        start_after: startOfYesterday,
        type: server_1.LESSON_CONFERENCE_TYPES,
        orderby: ['startline DESC'],
    });
    const { data: enterableConferenceData, refetch: refetchEnterableConferenceData } = (0, server_1.useConferenceList)({
        status: ['held', 'booked'],
        type: server_1.TEST_CONFERENCE_TYPE,
        orderby: ['startline ASC'],
    });
    const { data: enquiriesData, refetch: refetchEnquiriesData } = (0, server_1.useEnquiriesList)({
        conference_id: individualLive.map(i => i.id),
        ...(manager_local_id ? { host: manager_local_id } : {}),
        status: 'held',
        with_more_info: true,
    });
    const { data: spareLiveData, refetch: refetchSpareLive } = (0, server_1.useSpareLiveStreaming)(classesId);
    (0, react_1.useEffect)(() => {
        APP.eventManager.publish(constant_2.REFRESH_POSTS_LIST);
        APP.eventManager.publish('REFETCH_QNA_LIST');
        APP.eventManager.publish(constant_1.REFRESH_ASSIGNMENT_LIST);
        APP.eventManager.publish('REFRESH_REPLAY_LIST');
    }, [classesId]);
    (0, react_1.useEffect)(() => {
        setEnquiriesList([]);
        setLiveRoomName(undefined);
        setLiveRoomId(undefined);
        setLiveRoomCount(0);
        setIndividualLive([]);
        refetch();
        refetchEnterableConferenceData();
    }, [classesId, refetch, refetchEnterableConferenceData]);
    (0, react_1.useEffect)(() => {
        if (individualLive.length === 0)
            return;
        refetchEnquiriesData();
    }, [individualLive]);
    const getClosestByStartTime = (items, nowMs) => {
        if (!items?.length)
            return undefined;
        return items.reduce((best, cur) => {
            const curDiff = Math.abs(new Date(cur.start_time).getTime() - nowMs);
            const bestDiff = Math.abs(new Date(best.start_time).getTime() - nowMs);
            return curDiff < bestDiff ? cur : best;
        });
    };
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items, server_time } = data;
            if (total_count > 0) {
                //setIsLiveRoom(moment().isSame(items.start_time, 'day'));
                //1:1 질의응답 활성화
                // setIsOpenEnquiries(items[total_count - 1].status === 'closed' ? true : false);
                const closed_items = items.filter(i => ['closed'].includes(i.status));
                const has_qna_managers = closed_items.filter(i => i.qna_managers.length > 0);
                // 1:1 라이브 질의응답 - 조교 있는지 확인
                setIndividualLive(has_qna_managers);
                const filter_items = items.filter(i => ['held', 'booked'].includes(i.status));
                const now = new Date(server_time).getTime();
                const held_items = filter_items.filter((item) => {
                    if (item.status === "held")
                        return true;
                    const startTime = new Date(item.start_time).getTime();
                    const preEnteringTime = item.pre_entering_duration * 60 * 1000;
                    return now >= startTime - preEnteringTime && now <= startTime;
                });
                const closestFilterItem = getClosestByStartTime(filter_items, now);
                if (isTeacher && filter_items && filter_items.length > 0) {
                    setLiveRoomCount(filter_items.length);
                    setLiveRoomId(filter_items[0].id);
                    setIsOpenLive(true);
                    const hasSpareLive = filter_items.some(i => i.spare_live);
                    setHasSpareLive(hasSpareLive);
                }
                if (!isTeacher && held_items && held_items.length > 0) {
                    setLiveRoomCount(held_items.length);
                    setLiveRoomId(held_items[0].id);
                    setIsOpenLive(true);
                    const hasSpareLive = held_items.some(i => i.spare_live);
                    setHasSpareLive(hasSpareLive);
                }
                if (filter_items && filter_items.length > 0) {
                    setLiveRoomName(closestFilterItem?.title);
                }
                return;
            }
        }
        setLiveRoomCount(0);
        setIsOpenLive(false);
        setHasSpareLive(false);
        setLiveRoomId(undefined);
        setLiveRoomName(undefined);
    }, [data, isTeacher]);
    (0, react_1.useEffect)(() => {
        if (individualLive.length === 0) {
            setEnquiriesList([]);
            return;
        }
        if (enquiriesData) {
            const { total_count, items } = enquiriesData;
            if (total_count > 0) {
                setEnquiriesList(items);
            }
            else {
                setEnquiriesList([]);
            }
        }
    }, [enquiriesData, individualLive]);
    (0, react_1.useEffect)(() => {
        if (hasSpareLive) {
            refetchSpareLive();
        }
    }, [hasSpareLive]);
    (0, react_1.useEffect)(() => {
        if (spareLiveData) {
            setSpareLiveDatas(spareLiveData);
        }
    }, [spareLiveData]);
    // const { userName, userId } = useMemo(() => {
    // 	if (!user) {
    // 		return {
    // 			userName: '',
    // 			userId: '',
    // 		};
    // 	} else {
    // 		return {
    // 			userName: user.nickname,
    // 			userId: hideName(user.auth_name),
    // 		};
    // 	}
    // }, [user]);
    // const { classesTitle, classesDuration } = useMemo(() => {
    // 	if (!classes_data) {
    // 		return {
    // 			classesTitle: '',
    // 			classesDuration: '',
    // 		};
    // 	}
    // 	return {
    // 		classesTitle:
    // 			classes_data.title + (classes_data.subject ? '(' + classes_data.subject + ')' : ''),
    // 		classesDuration:
    // 			moment(classes_data.startline).format('YY/MM/DD (dd)') +
    // 			' ~ ' +
    // 			moment(classes_data.deadline).format('YY/MM/DD (dd)'),
    // 	};
    // }, [classes_data]);
    const openEnquiries = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            className: `${individualLive.length === 0 ? 'home-live-empty' : 'home-live'} ${isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop'}`,
            component: LiveEnquiries_1.LiveEnquiries,
            componentProps: {
                liveRoom: individualLive,
            },
            title: t('conference.liveInquiry'),
            height: 'auto',
        });
    };
    const goToLiveRoom = () => {
        dispatch((0, action_1.updateMenu)('liveRoom', {
            menu: 'reservation',
            detail: 'list',
        }));
    };
    const handleGoToConference = (id) => {
        if (liveRoomCount === 1) {
            (0, funtions_1.goToConference)(id);
        }
        else if (liveRoomCount > 1) {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: LiveRoomListPopUp_1.LiveRoomListPopUp,
                componentProps: {
                    allowedTypes: server_1.LESSON_CONFERENCE_TYPES,
                },
                width: 600,
                title: t('conference.enterLiveRoom'),
            });
        }
    };
    const handleGoToTestConference = () => {
        if (availableTestConferences.length === 1) {
            (0, funtions_1.goToConference)(availableTestConferences[0].id);
            return;
        }
        if (availableTestConferences.length > 1) {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                component: LiveRoomListPopUp_1.LiveRoomListPopUp,
                componentProps: {
                    allowedTypes: server_1.TEST_CONFERENCE_TYPE,
                    titleText: t('conference.availableTestRooms'),
                    guideText: t('conference.selectTestRoom'),
                    // 테스트 응시 팝업: 테스트 리스트와 동일하게 등록일(creation_time) 최신순 정렬
                    orderby: ['creation_time DESC'],
                },
                width: 600,
                title: t('conference.takeTest'),
            });
        }
    };
    const goToSpareLive = () => {
        if (spareLiveDatas && spareLiveDatas.player_url) {
            window.open(spareLiveDatas.player_url, 'popupPage', 'directories=no,titlebar=no,toolbar=no,status=no,menubar=no,location=yes,width=1920,height=964,scrollbars=yes');
        }
    };
    (0, react_1.useEffect)(() => {
        if (!classes || classesId === classes || classes === 'select')
            return;
        navigate(`/class/${classes}`);
    }, [classes]);
    const getEnterableConferences = (items, serverTime) => {
        if (isTeacher)
            return items;
        const now = new Date(serverTime || new Date().toISOString()).getTime();
        return items.filter(item => {
            if (item.status === 'held')
                return true;
            const startTime = new Date(item.start_time).getTime();
            const preEnteringTime = item.pre_entering_duration * 60 * 1000;
            return now >= startTime - preEnteringTime && now <= startTime;
        });
    };
    const availableTestConferences = (0, react_1.useMemo)(() => {
        const allConferences = (enterableConferenceData?.items || []);
        const enterableConferences = getEnterableConferences(allConferences, enterableConferenceData?.server_time);
        return enterableConferences;
    }, [enterableConferenceData, isTeacher]);
    const canEnterTest = availableTestConferences.length > 0;
    if (!classes_data)
        return null;
    return (react_1.default.createElement(ProfileStyled, { "$isMobile": isMobile, "$isTablet": isTablet },
        react_1.default.createElement("div", { className: "left" },
            react_1.default.createElement("div", { className: "profile" },
                react_1.default.createElement("div", { className: "name-info" },
                    react_1.default.createElement(classes_1.ClassesDropDown, { userId: user.id, userTenantId: user.tenant_id, defaultClasses: classesId || 'select', setClasses: setClasses })),
                !hiddenMenus.includes('reservation') && (react_1.default.createElement("div", { className: "class-info" },
                    react_1.default.createElement("div", { className: "alarm-today" },
                        react_1.default.createElement("div", { className: "btn-today" },
                            react_1.default.createElement("div", { className: "today" }, t('common.today'))),
                        react_1.default.createElement("div", { className: "info" },
                            react_1.default.createElement("div", { className: "txt overText2" }, liveRoomName ? liveRoomName : t('conference.noScheduledClass')),
                            liveRoomName && (react_1.default.createElement("div", { className: "btn-today2", onClick: goToLiveRoom },
                                react_1.default.createElement("div", { className: "div" }, t('common.more')),
                                react_1.default.createElement(common_1.Icon, { className: "arrow-right", icon: "arrow", size: 24, fill: "#ffffff" }))))))))),
        react_1.default.createElement("div", { className: "right", style: hasSpareLive ? { width: isMobile ? '80%' : isTablet ? '310px' : '426px', gap: isMobile ? '12px' : '20px' } : {} }, !hiddenMenus.includes('reservation') && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "background" }),
            hasSpareLive ? (react_1.default.createElement("div", { className: 'enter-buttons' },
                react_1.default.createElement(common_1.Button, { className: `btn-classroom-in spare ${(isTeacher || isOpenLive) && liveRoomId ? 'on' : 'disabled'}`, text: isMobile ? t('conference.enterClass') : t('conference.conference'), secondText: !isMobile && t('common.enter'), onClick: () => (isTeacher || isOpenLive) &&
                        liveRoomId &&
                        handleGoToConference(liveRoomId), styles: {
                        buttonWrap: { flexDirection: 'column' }
                    } }),
                react_1.default.createElement(common_1.Button, { className: `btn-classroom-in spare ${(isTeacher || isOpenLive) && liveRoomId ? 'on' : 'disabled'}`, text: isMobile ? t('conference.enterSpareLiveRoom') : t('conference.spareLive'), secondText: !isMobile && t('conference.enterRoom'), onClick: () => goToSpareLive(), styles: {
                        buttonWrap: { flexDirection: 'column' }
                    } }))) : (react_1.default.createElement(common_1.Button, { className: `btn-classroom-in ${(isTeacher || isOpenLive) && liveRoomId ? 'on' : 'disabled'}`, text: t('conference.enterClass'), onClick: () => (isTeacher || isOpenLive) &&
                    liveRoomId &&
                    handleGoToConference(liveRoomId) })),
            react_1.default.createElement("div", { className: "secondary-buttons" },
                react_1.default.createElement(common_1.Button, { className: `btn-classroom-personal ${canEnterTest ? 'on' : 'disabled'} ${hasSpareLive && 'spare'}`, text: t('conference.takeTest'), onClick: handleGoToTestConference }),
                react_1.default.createElement("button", { type: "button", className: `btn-qna-link ${enquiriesList.length > 0 ? 'on' : 'disabled'}`, onClick: () => enquiriesList.length > 0 && openEnquiries() }, t('conference.liveQna'))))))));
});
